import { Component } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';

@Component({
  selector: 'muni-gameday-order-number',
  styleUrls: ['./order-number.styles.scss'],
  template: `
    <div
      class="order-number-container"
      *ngIf="
        displayValue !== undefined &&
        displayValue !== null &&
        displayValue !== ''
      "
    >
      <span
        class="order-number"
        [textContent]="
          isNumericValue ? (displayValue | number: '1.0-2') : displayValue
        "
        [title]="
          isNumericValue ? (displayValue | number: '1.0-2') : displayValue
        "
      >
      </span>
      <muni-gameday-comment *ngIf="comments" [text]="comments" class="comments">
      </muni-gameday-comment>
    </div>
  `,
  standalone: false
})
export class OrderNumberComponent implements ICellRendererAngularComp {
  public displayValue: string | number;
  public comments = '';
  public isNumericValue = false;

  private syncFromParams(params: ICellRendererParams): void {
    this.displayValue = params?.value;
    this.comments = params?.data?.comments || '';
    this.isNumericValue =
      this.displayValue !== null &&
      this.displayValue !== undefined &&
      this.displayValue !== '' &&
      !Number.isNaN(Number(this.displayValue));
  }

  public agInit(params: ICellRendererParams) {
    this.syncFromParams(params);
  }

  public refresh(params: ICellRendererParams): boolean {
    this.syncFromParams(params);
    return true;
  }
}
